import React from "react";
import { Box, Dialog, Grid, IconButton, Typography } from "@material-ui/core";
import { Close } from "@material-ui/icons";

import { css } from "./styles";

export const ModalBloqueioAntecipacao = ({ isModalOpen, handleCloseModal, produtos }) => {
    const styles = css();

    return (
        <Dialog open={isModalOpen} onClose={handleCloseModal}>
            <Grid container className={styles.container}>
                <Box className={styles.header}>
                    <Typography className={styles.title}>
                        Antecipação de Pagamento Indisponível
                    </Typography>

                    <IconButton className={styles.closeButton} onClick={handleCloseModal}>
                        <Close />
                    </IconButton>
                </Box>

                <Grid item className={styles.text}>
                    Há item(s) de pedido já parcialmente entregue(s). Entre em contato com a equipe
                    Tok&Stok para realização do desmembramento da quantidade pendente, para que ela
                    possa ser antecipada.
                </Grid>

                {produtos && (
                <Box className={styles.produtos}>
                    {produtos.map((item, i) => (
                        <Typography key={i} style={{ marginBottom: "7.5px" }}>
                            &bull; Número do pedido: {item.nr_pedido} - 
                            Id do produto: {item.id_produto}
                        </Typography>
                    ))}
                </Box>
                )}
            </Grid>
        </Dialog>
    );
};
